import { Footer } from "../components/Footer"
import { PriorityMethods } from "../components/deposit/PriorityMethods"
import { R4Conecta } from "../components/deposit/R4Conecta"


export const DepositR4ConectaPage = () => {
    return (
        <div className="container">
            <PriorityMethods />
            <R4Conecta />
            <Footer />
        </div>
    );
}